import React, { useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  RadioGroup,
  FormControl,
  Box,
  Chip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PreviewComponent from "../pages/mockTest/QuestionFormComponentMock/previewComponent";
import mathFunction from "../pages/exams/mathFunction";
import CustomTab from "./CustomTab";
export const formatOptions = (htmlString: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  // Remove <p> and <span> tags but preserve children
  const tagsToRemove = ["p", "span"];
  
  tagsToRemove.forEach((tag) => {
    const elements = doc.querySelectorAll(tag);
    elements.forEach((el) => {
      const parent = el.parentNode;
      if (!parent) return;
      while (el.firstChild) {
        parent.insertBefore(el.firstChild, el);
      }
      parent.removeChild(el);
    });
  });

  // Remove inline styles only from non-essential tags (not img or div)
  const elementsWithStyle = doc.querySelectorAll("[style]");
  elementsWithStyle.forEach((el) => {
    const tagName = el.tagName.toLowerCase();
    if (tagName !== "img" && tagName !== "div") {
      el.removeAttribute("style");
    }
  });

  const removeIncompleteTags = (htmlContent: string) => {
    // Remove orphaned opening tags with no closing counterparts
    htmlContent = htmlContent.replace(/<p[^>]*>(?![\s\S]*<\/p>)/gi, "");
    htmlContent = htmlContent.replace(/<span[^>]*>(?![\s\S]*<\/span>)/gi, "");

    // Remove orphaned closing tags with no opening counterparts
    htmlContent = htmlContent.replace(/<\/p>(?![\s\S]*<p[^>]*>)/gi, "");
    htmlContent = htmlContent.replace(/<\/span>(?![\s\S]*<span[^>]*>)/gi, "");

    // Optional: Normalize whitespace
    return htmlContent.trim().replace(/\s+/g, " ");
  };

  const cleanedHTML = removeIncompleteTags(doc.body.innerHTML);
  return cleanedHTML;
};

export const formatQuestion=(htmlContent: string)=>{
  return   htmlContent
  .replace(/font-family:\s*["']?[^;"']*["']?;?/gi, "")  // Remove font-family
  .replace(/font-size:\s*["']?[^;"']*["']?;?/gi, "")   // Remove font-size
  .replace(/color:\s*["']?[^;"']*["']?;?/gi, "")   // Remove color
  .replace(/font-family:\s*['"]?Times New Roman['"]?;?/gi, '')
  .replace(/Times New Roman&quot;;/g, '')
  .replace(/\s*;$/g, ''); 
}
export const formatTags = (htmlString: any) => {
  // Create a DOM parser
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  // Remove all <p> and <span> tags
  const tagsToRemove = ["p", "span"];
  tagsToRemove.forEach((tag) => {
    const elements = doc.querySelectorAll(tag);
    elements.forEach((el) => {
      const parent: any = el.parentNode;
      while (el.firstChild) {
        parent.insertBefore(el.firstChild, el);
      }
      parent.removeChild(el);
    });
  });

  // Remove inline styles
  const elementsWithStyle = doc.querySelectorAll("[style]");
  elementsWithStyle.forEach((el) => el.removeAttribute("style"));
  const removeIncompleteTags = (htmlContent: string) => {
    // // Remove empty or self-closing <p> and <span> tags
    // htmlContent = htmlContent.replace(/<p[^>]*>\s*<\/p>/gi, "");
    // htmlContent = htmlContent.replace(/<span[^>]*>\s*<\/span>/gi, "");

    // Remove orphaned opening <p> or <span> tags without closing counterparts
    htmlContent = htmlContent.replace(/<p[^>]*>(?![\s\S]*<\/p>)/gi, "");
    htmlContent = htmlContent.replace(/<span[^>]*>(?![\s\S]*<\/span>)/gi, "");

    // Remove orphaned closing </p> or </span> tags without opening counterparts
    htmlContent = htmlContent.replace(/<\/p>(?![\s\S]*<p[^>]*>)/gi, "");
    htmlContent = htmlContent.replace(/<\/span>(?![\s\S]*<span[^>]*>)/gi, "");

    // // Remove any remaining `<br>` or `<undefined>` tags
    htmlContent = htmlContent.replace(/&nbsp;/gi, " ");
    // htmlContent = htmlContent.replace(/<\/?undefined>/gi, "");

    // Trim and normalize whitespace
    return htmlContent.trim().replace(/\s+/g, " ");
  };
  return removeIncompleteTags(doc.body.innerHTML);
};

interface QuestionPreviewProps {
  questionPreviewData:any; // Ensure this is passed
  language_available: string[]; // Define language_available as an array of strings
}

const QuestionPreview: React.FC<QuestionPreviewProps> = ({
  questionPreviewData,
  language_available,
}) => {
  
  const [selectedLanguage, setSelectedLanguage] = React.useState<number>(0);

  const handleLanguageChange = (newValue: number) => {
    setSelectedLanguage(newValue);
  };

  useEffect(() => {
    mathFunction();
  }, [selectedLanguage]);
  const cont = (
    <Card variant="outlined" sx={{ maxWidth: "100%"}}>
   
      <CardContent>
        <Typography variant="body2">
          <PreviewComponent
            htmlContent={
              questionPreviewData?.translation &&
              questionPreviewData?.translation.find(
                (trans: any) =>
                  trans.language ===
                  (selectedLanguage === 0 ? "english" : "hindi")
              )?.text
            }
          />
        </Typography>
        <FormControl component="fieldset">
          <RadioGroup>
            <Grid container spacing={2}>
              {questionPreviewData?.options?.map(
                (option: any, index: number) => (
                  <Grid item xs={12} key={option.order}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "15px",
                        fontWeight: "100",
                        border: "1px solid grey",
                        borderRadius: "5px",
                        padding: "10px",
                        marginTop: "15px",
                      }}
                    >
                      {["A", "B", "C", "D"][index]}.&nbsp;
                      <PreviewComponent
                        htmlContent={formatOptions(
                          option.translation.find(
                            (trans: any) =>
                              trans.language ===
                              (selectedLanguage === 0 ? "english" : "hindi")
                          )?.text)
                        }
                      />
                      <div style={{ marginLeft: "auto" }}>
                        {option.is_correct ? (
                          <CheckCircleIcon style={{ color: "green" }} />
                        ) : null}
                      </div>
                    </div>
                  </Grid>
                )
              )}
            </Grid>
          </RadioGroup>
        </FormControl>
        {questionPreviewData?.explanation && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              Explanation:
            </Typography>
            <Typography variant="body2">
              <PreviewComponent
                htmlContent={
                  questionPreviewData?.explanation?.translation &&
                  questionPreviewData?.explanation.translation.find(
                    (trans: any) =>
                      trans.language ===
                      (selectedLanguage === 0 ? "english" : "hindi")
                  )?.text
                }
              />
            </Typography>
          </Box>
        )}
        {questionPreviewData?.tag?.length > 0 && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              Question Tags:
            </Typography>
            <Typography variant="body2">
              <Chip
                sx={{
                  margin: "5px",
                  background: "#E3F4E7",
                  maxWidth: "calc(100% - 10px)",
                  "& .MuiChip-label": {
                    fontSize: "0.69srem",
                    lineHeight: "1rem",
                  },
                }}
                label={formatTags(questionPreviewData?.tag[0]?.name)}
                variant="outlined"
              />
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
  const allTab = language_available?.includes("hindi")
    ? [
        { id: 0, tab: "English", content: cont },
        { id: 1, tab: "Hindi", content: cont },
      ]
    : [{ id: 0, tab: "English", content: cont }];
  return (
    <CustomTab
      selected={allTab.find((it) => it.id === selectedLanguage)}
      tabs={allTab}
      onChange={(id: number) => {
        handleLanguageChange(id);
      }}
      badgeCount={{}}
    />
  );
};

export default QuestionPreview;
